export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";